

$(document).ready(function(){
  console.log("hfg");
  $('.article-item__title').matchHeight();
  $('.events-carousel').slick({
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesPerRow: 3,
    rows: 2,
    prevArrow: $('.prev-arrow'),
    nextArrow: $('.next-arrow'),
    appendDots: $('.your-dots-container'),
    customPaging: function(slider, i) {
        return '<button type="button">' + (i + 1) + '</button>';
    },
    centerMode: false,
    responsive: [
      {
        breakpoint: 998, // this is generally the max-width for most mobile devices
        settings: {
          slidesToShow: 1,
          slidesPerRow: 1,
          rows: 2
        }
      }
    ]
  });

  if ( $('#newAboutCarousel').length ) {
    var aboutCarousel = $('#newAboutCarousel').slick({
      dots: true,
      adaptiveHeight: true,
      prevArrow: $('#customPrevButton'),
      nextArrow: $('#customNextButton')
    });
  }

    $('.accolades-section .multi-column__grid').on('init', function(event, slick) {
      $(this).addClass('slick-visible');
    });
    $('.accolades-section .multi-column__grid').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
    });

  
  $('.expand-contact-form-button').on('click', function() {
    $('.contact-form__inner').slideUp();
    $('.expand-contact-form-button').fadeIn();
    var parentContainer = $(this).closest('.contact-form');
    var innerContent = parentContainer.find('.contact-form__inner');
    innerContent.slideDown();
    $(this).fadeOut();  // Check for an iframe within innerContent and update the scrolling attribute
    var iframe = innerContent.find('iframe');
    if (iframe.length > 0) {
        iframe.attr('scrolling', 'yes'); // Update scrolling attribute
        // Alternatively, handle CSS solution for scrolling
        iframe.css('overflow', 'scroll');
    }
  });

  // Check if URL has a hash
  if(window.location.hash) {
      var hash = window.location.hash.substring(1); // Get hash, excluding '#'
      var targetButton = $('.expand-contact-form-button[data-form-title="' + hash + '"]');
      var targetFaq = $('.collapsible-row-list-item__trigger[data-remote-trigger="' + hash + '"]');

      // Check if the target button exists
      if(targetButton.length) {
        targetButton.click(); // Simulate click

        // Scroll to the top of the content parent element
        var contentParent = targetButton.closest('.contact-form__content');
        if(contentParent.length) {
            $('html, body').animate({
                scrollTop: contentParent.offset().top - 120
            }, 1000);
        }
    }
    // Check if the target FAQ exists
    if(targetFaq.length) {
      targetFaq.click(); // Simulate click

        // Scroll to the top of the content parent element
        var contentParent = targetFaq.closest('.collapsible-row-list-item');
        if(contentParent.length) {
            $('html, body').animate({
                scrollTop: contentParent.offset().top - 120
            }, 1000);
        }
    }
  }


  const $modalWrapper = $('#madeToOrderModalWrapper');
  
  $('.close-modal, .mto-atc').on('click', function() {
    $modalWrapper.fadeOut();
  });

});


document.addEventListener('DOMContentLoaded', () => {
  // Function to set up MutationObserver on shadow DOM
  const observeShadowDOM = () => {
    const element = document.querySelector('shop-pay-installments-banner');
    if (element && element.shadowRoot) {
      // Access shadow DOM
      const shadowRoot = element.shadowRoot;
      // Define what to observe and callback
      const config = { childList: true, subtree: true };
      const callback = (mutationsList, observer) => {
        for(const mutation of mutationsList) {
          if (mutation.type === 'childList') {
            console.log('A child node has been added or removed.');
            // Your logic to handle the change
          }
        }
      };
      // Create and attach the observer
      const observer = new MutationObserver(callback);
      observer.observe(shadowRoot, config);
      console.log('Shadow DOM observer attached');
    } else {
      // If the element is not yet available, check back later
      setTimeout(observeShadowDOM, 500);
    }
  };

  // Initial attempt to set up the observer
  observeShadowDOM();


  function initializeHoverEffects(hoverElement) {
    const parent = hoverElement.parentElement;
    const tooltip = parent.nextElementSibling;
    
    console.log({parent});
    console.log({tooltip});
  
    if (!tooltip || !tooltip.classList.contains('tooltip')) {
      console.error('Tooltip element not found or not correctly positioned after hover element:', hoverElement);
      return;
    }
  
    hoverElement.addEventListener('mouseenter', function() {
      const text = hoverElement.getAttribute('data-cart-hover-text');
      tooltip.innerHTML = text;
      tooltip.style.display = 'block';
    });
  
    hoverElement.addEventListener('mouseleave', function() {
      tooltip.style.display = 'none';
    });
  
    hoverElement.addEventListener('mousemove', function(event) {
      const hoverRect = hoverElement.getBoundingClientRect();
  
      let tooltipX = event.clientX - hoverRect.left;
      let tooltipY = event.clientY - hoverRect.top - tooltip.offsetHeight - 10; // 10px offset above the cursor
  
      // Ensure the tooltip stays within the parent element horizontally
      if (tooltipX + tooltip.offsetWidth > hoverRect.width) {
        tooltipX = hoverRect.width - tooltip.offsetWidth - 10; // 10px offset from the right edge
      }
  
      // Ensure the tooltip stays within the parent element vertically
      if (tooltipY < 0) {
        tooltipY = event.clientY - hoverRect.top + 10; // 10px offset below the cursor if above the element
      }
  
      // Set the tooltip position
      tooltip.style.left = `${tooltipX}px`;
      tooltip.style.top = `${tooltipY}px`;
    });
  }
  
  document.querySelectorAll('.made-to-order-hover').forEach(initializeHoverEffects);
  
  // Set up a MutationObserver to handle dynamically added elements
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1 && node.matches('.made-to-order-hover')) {
          initializeHoverEffects(node);
        } else if (node.nodeType === 1) {
          node.querySelectorAll('.made-to-order-hover').forEach(initializeHoverEffects);
        }
      });
    });
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
  


});






